// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import type { ImageSourcePropType } from 'react-native';
import logoIcon from './icon-transparent.png';
import logoFull from './logo-full.png';

export const LogoIcon = logoIcon as ImageSourcePropType;
export const LogoFull = logoFull as ImageSourcePropType;
